/* src/app/core/containers/not-found/not-found.component.scss */
.error-page {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
}
.error-page__404 {
  font-size: 14rem;
  font-weight: bold;
  font-family: var(--mp-font-heading);
}
p {
  text-align: center;
}
/*# sourceMappingURL=not-found.component.css.map */
